import { createAction } from '@reduxjs/toolkit'

export resetFilteredNodes           = createAction('filter/filteredNodesReset')
export resetFilteredRelations       = createAction('filter/filteredRelationsReset')
export resetGraphFilters            = createAction('filter/graphsReset')
export resetRelationFilters         = createAction('filter/relationsReset')
export resetTypeFilters             = createAction('filter/typesReset')

export setActiveFilterTab           = createAction('filter/activeTabSet')
export setFilteredNodesByGraph      = createAction('filter/filteredNodesByGraphSet')
export setFilteredNodesByOther      = createAction('filter/filteredNodesByOtherSet')
export setFilteredNodesByRelation   = createAction('filter/filteredNodesByRelationSet')
export setFilteredNodesBySearch     = createAction('filter/filteredNodesBySearchSet')
export setFilteredNodesByType       = createAction('filter/filteredNodesByTypeSet')
export setFilteredRelationsByKey    = createAction('filter/filteredRelationsByKeySet')
export setFilteredRelationsByOther  = createAction('filter/filteredRelationsByOtherSet')
export setGraphFilters              = createAction('filter/graphsSet')
export setHideNamelessNodeLabels    = createAction('filter/namelessNodeLabelsHidden')
export setHideRelationLabels        = createAction('filter/relationLabelsHidden')
export setRelationFilters           = createAction('filter/relationsSet')
export setShowRelationsAsNodes      = createAction('filter/relationsAsNodesShown')
export setTypeFilters               = createAction('filter/typesSet')

export updateGraphFilter            = createAction('filter/graphUpdated')
export updateGraphFilters           = createAction('filter/graphsUpdated')
export updateRelationFilter         = createAction('filter/relationUpdated')
export updateRelationFilters        = createAction('filter/relationsUpdated')
export updateTypeFilter             = createAction('filter/typeUpdated')
export updateTypeFilters            = createAction('filter/typesUpdated')
